import { NavigateBefore } from "@mui/icons-material";
import useApi from "_api/index";
import RenderDetailCar from "components/Car/RenderDetailCar";
import RenderFieldsCustomers from "components/Car/RenderFieldsCustomers";
import { GradientButton } from "components/GradientButton";
import { useFormik } from "formik";
import { useAuth } from "hooks/useAuth";
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  Typography,
  DialogActions,
  DialogContent,
  Button,
  Box,
  Grid,
  TextField,
  Autocomplete,
  colors,
} from "@mui/material";
import * as Yup from "yup";

const ModalCarMarketPlace = ({ open, onClose, id }) => {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  const [customerImage, setCustomerImage] = useState([]);
  const [packages, setPackages] = useState([]);
  const { user } = useAuth();
  useEffect(() => {
    if (open && id) {
      fetchData();
    }
  }, [open, id]);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    await useApi.super_admin
      .getCompanyMarketPlace(user?.company_id)
      .then((response) => {
        if (response.isStatus) {
          setPackages(response.data || []);
        } else {
          console.error("Failed to fetch packages:", response.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching packages:", error);
      });
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await useApi.ready_car.getReadySellCarById(id);
      if (response.success) {
        setDetail(response.data);
        const { customer, car } = response.data;
        const customet_format = {
          prefix: customer.customer_prefix || "",
          fullName: customer.customer_name || "",
          idCardNumber: customer.customer_idcard || "",
          phoneNumber: customer.customer_phonenumber || "",
          address: customer.customer_address || "",
          nationality: customer.customer_nationality || "ไทย",
        };
        if (customer.customer_image) {
          setCustomerImage([
            {
              url: customer.customer_image,
              name: "customer_image",
            },
          ]);
        } else {
          setCustomerImage([]);
        }

        formik.setValues({
          ...customet_format,
          sell_price: car.sell_price ? car.sell_price : car.car_price || 0,
        });
      } else {
        console.error("Failed to fetch car details:", response.message);
      }
    } catch (error) {
      console.error("Error fetching car details:", error);
    } finally {
      setLoading(false);
    }
  };
  const generateInitialValues = () => {
    return {
      // ข้อมูลลูกค้า
      prefix: "",
      fullName: "",
      idCardNumber: "",
      phoneNumber: "",
      address: "",
      nationality: "",

      // ข้อมูลการส่งรถไป marketplace
      marketplace_company_id: null,
      marketplace_address: "",
      package_type: "",
      total_credit_remain: 0,
      sell_price: 0,
    };
  };

  const formik = useFormik({
    initialValues: generateInitialValues(),
    validationSchema: Yup.object({
      marketplace_company_id: Yup.number()
        .typeError("กรุณาเลือกแพ็คเกจ")
        .required("กรุณาเลือกแพ็คเกจ")
        .nullable(),
    }),
    onSubmit: async (values) => {
      console.log("Formik errors:", formik.errors);
      setLoading(true);
      const formattedValues = {
        id: detail?.car.car_id ?? null,
        marketplace_company_id: values.marketplace_company_id,
        marketplace_address: values.marketplace_address,
      };
      try {
        const response = await useApi.ready_car.sendCarToMarketPlace(
          formattedValues
        );
        if (response.isStatus || response.success) {
          console.log(
            "Car sent to marketplace successfully:",
            response.message
          );
          onClose();
        } else {
          console.error("Failed to send car to marketplace:", response.message);
        }
      } catch (error) {
        console.error("Error sending car to marketplace:", error);
      } finally {
        setLoading(false);
      }
    },
  });

  if (!detail) {
    return null; // or a loading spinner if you prefer
  }
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onClose();
        }
      }}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          padding: 2,
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h4">ส่งรถไป Marketplace</Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          padding: 2,
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: 8,
            height: 8,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: colors.grey[300],
            borderRadius: 4,
          },
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <RenderFieldsCustomers
            formik={formik}
            images={customerImage}
            setCustomerImage={setCustomerImage}
            disabled={true}
          />
          <RenderDetailCar car={detail?.car} sx={{ mt: 2 }} />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              mt: 2,
            }}
          >
            <Typography variant="h5">ข้อมูลการส่งรถไป Marketplace</Typography>
            <Box
              sx={{
                p: 2,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={3}>
                      <Typography variant="body1">ราคาขาย</Typography>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="กรอกราคาขาย"
                        name="sell_price"
                        type="number"
                        value={formik.values.sell_price || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.sell_price &&
                          Boolean(formik.errors.sell_price)
                        }
                        helperText={
                          formik.touched.sell_price && formik.errors.sell_price
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            bgcolor: "white",
                            height: "40px",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="body1">ช่องทางการติดต่อ</Typography>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="กรอกช่องทางการติดต่อ"
                        name="marketplace_address"
                        multiline
                        rows={4}
                        value={formik.values.marketplace_address || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.marketplace_address &&
                          Boolean(formik.errors.marketplace_address)
                        }
                        helperText={
                          formik.touched.marketplace_address &&
                          formik.errors.marketplace_address
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={3}>
                      <Typography variant="body1">แพ็คเกจ</Typography>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <Autocomplete
                        fullWidth
                        options={packages}
                        getOptionLabel={(option) => option.name_package}
                        getOptionKey={(option) => option.marketplace_company_id}
                        value={
                          packages.find(
                            (pkg) =>
                              pkg.marketplace_company_id ===
                              formik.values.marketplace_company_id
                          ) || null
                        }
                        onChange={(event, value) => {
                          formik.setFieldValue(
                            "marketplace_company_id",
                            value?.marketplace_company_id || null
                          );
                          formik.setFieldValue(
                            "package_type",
                            value?.package_type
                          );
                          formik.setFieldValue(
                            "total_credit_remain",
                            value?.total_credit_remain || 0
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="เลือกแพ็คเกจ"
                            name="marketplace_company_id"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                bgcolor: "white",
                                height: "40px",
                              },
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.marketplace_company_id &&
                              Boolean(formik.errors.marketplace_company_id)
                            }
                            helperText={
                              formik.touched.marketplace_company_id &&
                              formik.errors.marketplace_company_id
                            }
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={3}>
                      <Typography variant="body1">ประเภทแพ็คเกจ</Typography>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="package_type"
                        placeholder="กรุณาเลือกแพ็คเกจ"
                        value={
                          formik.values.package_type === "normal"
                            ? "สินค้าอื่นๆ"
                            : formik.values.package_type === "popular"
                            ? "สินค้ายอดฮิต"
                            : ""
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            bgcolor: "white",
                            height: "40px",
                            color: colors.grey[500],
                          },
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={3}>
                      <Typography variant="body1">เครดิตคงเหลือ</Typography>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="กรุณาเลือกแพ็คเกจ"
                        name="total_credit_remain"
                        value={formik.values.total_credit_remain || 0}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            bgcolor: "white",
                            height: "40px",
                            color: colors.grey[500],
                          },
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </form>
      </DialogContent>

      {/* ปุ่มปิด modal */}
      <DialogActions
        sx={{
          justifyContent: "space-between",
          borderTop: `1px solid ${colors.grey[300]}`,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            borderRadius: 2,
            width: "auto",
            borderColor: colors.grey[400],
            color: colors.grey[400],
            "&:hover": {
              borderColor: colors.grey[400],
              color: colors.grey[400],
              borderWidth: 2,
              bgcolor: "transparent",
            },
          }}
        >
          <NavigateBefore
            sx={{
              width: 30,
              height: 30,
            }}
          />
        </Button>

        <GradientButton
          onClick={formik.handleSubmit}
          sx={{
            width: "auto",
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          type="submit"
          disabled={loading}
          loading={loading}
        >
          <Typography sx={{ fontSize: "16px" }}>บันทึก</Typography>
        </GradientButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCarMarketPlace;
